module.exports = function getResource(label, vars = []) {
    let resources = {
        next2Weeks: 'Next 2 weeks',
        orChooseDate: 'Or choose a date',
        filterByDate: 'Filter by Date'
    };
    return resources[label];
};
